// extracted by mini-css-extract-plugin
module.exports = {"header":"AdminHeader_header__Nv9l6","active":"AdminHeader_active__1uzv8"};